// index.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import polygonClipping from "polygon-clipping";
import { multiPolygon, polygon } from "@turf/helpers";
import { geomEach } from "@turf/meta";
function union(features) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _polygonClipping;
    var geoms = [];
    geomEach(features, function(geom) {
        geoms.push(geom.coordinates);
    });
    if (geoms.length < 2) {
        throw new Error("Must have at least 2 geometries");
    }
    var unioned = (_polygonClipping = polygonClipping).union.apply(_polygonClipping, [
        geoms[0]
    ].concat(_to_consumable_array(geoms.slice(1))));
    if (unioned.length === 0) return null;
    if (unioned.length === 1) return polygon(unioned[0], options.properties);
    else return multiPolygon(unioned, options.properties);
}
var turf_union_default = union;
export { turf_union_default as default, union }; //# sourceMappingURL=index.js.map
